import { ENV } from '@/shared/config';
import { PACKAGE_CODE, PLATFORM_CODE, SERVICE_CODE } from '@/shared/utils';
import type { CreditMenuLink, FamilyItem } from '@ncai-axe/react-ui-v3';
import IcHistory from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_history.svg';
import IcHome from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_home.svg';
import IcMail from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_mail.svg';
import IcPlanFill from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_plan_fill.svg';
import IcQuestionCircleLine from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_question_circle_line.svg';
import IcScriptdetail from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_scriptdetail.svg';

const FAMILY_LINK_URLS = {
  // VAETKI (외부 도메인은 그대로)
  vaetki: 'https://www.vaetki.ai',
  // 현재 호스트(origin) 기준으로 동작하도록 path-only 로 보관
  commerce: '/ko',
  commerceEn: '/en',
  helpCenter: '/ko/blog',
  helpCenterEn: '/en/blog',
};

type Language = 'ko' | 'en';

// TODO: refactor
export const getFamilyLinks = (lang?: Language): FamilyItem[] => [
  {
    icon: <IcQuestionCircleLine />,
    name: {
      ko: '도움말 센터',
      en: 'Help Center',
      zh: '帮助中心',
      es: 'Centro de ayuda',
      ja: 'ヘルプセンター',
      fr: "Centre d'aide",
      de: 'Hilfe-Center',
    },
    url:
      lang === 'ko'
        ? FAMILY_LINK_URLS.helpCenter
        : FAMILY_LINK_URLS.helpCenterEn,
    target: '_blank',
  },
  {
    icon: <IcMail />,
    name: {
      ko: '문의하기',
      en: 'Contact Us',
      zh: '联系我们',
      es: 'Contáctenos',
      ja: 'お問い合わせ',
      fr: 'Nous contacter',
      de: 'Kontakt',
    },
    url: 'mailto:vaetki-commerce@ncsoft.com',
  },
  { type: 'separator' },
  {
    icon: <IcHome />,
    name: {
      ko: 'VAETKI',
      en: 'VAETKI',
      zh: 'VAETKI',
      es: 'VAETKI',
      ja: 'VAETKI',
      fr: 'VAETKI',
      de: 'VAETKI',
    },
    url: FAMILY_LINK_URLS.vaetki,
    target: '_blank',
  },
  {
    icon: <span />,
    name: {
      ko: 'Commerce',
      en: 'Commerce',
      zh: 'Commerce',
      es: 'Commerce',
      ja: 'Commerce',
      fr: 'Commerce',
      de: 'Commerce',
    },
    url:
      lang === 'ko' ? FAMILY_LINK_URLS.commerce : FAMILY_LINK_URLS.commerceEn,
    target: '_blank',
  },
];

export const VAETKI_PRICING_URL = `https://vaetki.ai/ko/pricing`;

export const creditLinks = (lang: Language, plan: string): CreditMenuLink[] => [
  {
    icon: <IcPlanFill />,
    name: {
      ko: '내 요금제',
      en: 'My Plan',
      zh: '我的套餐',
      es: 'Mi plan',
      ja: '料金プラン',
      fr: 'Mon forfait',
      de: 'Mein Tarif',
    },
    url: `${ENV.MY_APP}/${lang === 'ko' ? 'ko' : 'en'}/my/subscription/commerce`,
    badge: plan,
  },
  {
    icon: <IcHistory />,
    name: {
      ko: '요금제 업그레이드',
      en: 'Upgrade Plan',
      zh: '升级套餐',
      es: 'Actualizar plan',
      ja: 'プランをアップグレード',
      fr: 'Mettre à niveau le forfait',
      de: 'Tarif upgraden',
    },
    url: VAETKI_PRICING_URL,
  },
  {
    icon: <IcScriptdetail />,
    name: {
      ko: '사용 내역',
      en: 'Usage History',
      zh: '使用历史',
      es: 'Historial de uso',
      ja: '利用履歴',
      fr: "Historique d'utilisation",
      de: 'Nutzungsverlauf',
    },
    url: `${ENV.MY_APP}/${lang === 'ko' ? 'ko' : 'en'}/my/credit/commerce`,
  },
];

export const consentCodes = {
  platformCode: PLATFORM_CODE.VAETKI_SAAS,
  packageCode: PACKAGE_CODE.COMMERCE,
  serviceCode: SERVICE_CODE.COMMERCE,
};
